import React, { useEffect } from 'react'
import { Skeleton } from '../Skeleton'
import { AnimatedChatAvatarS as AiAgentWidget } from '../AiAgent/AiAgentWidget'
import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

const Container = styled.div`
  position: fixed;
  inset: 0;
  z-index: 90;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f8fafc;
  animation: ${fadeIn} 0.3s ease-in-out;
`

const TopBar = styled.div`
  height: 60px;
  border-bottom: 1px solid #e2e8f0;
  background: white;
  display: flex;
  align-items: center;
  padding: 0 24px;
  gap: 24px;
`

const Sidebar = styled.div`
  width: 240px;
  border-right: 1px solid #e2e8f0;
  background: white;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const ContentArea = styled.div`
  flex: 1;
  padding: 32px;
  position: relative;
  display: flex;
  flex-direction: column;
`

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(4px);
  flex-direction: column;
  gap: 16px;
  z-index: 10;
`

export function FullAppLoader({ 
  hasSidebar = true, 
  hasTopbar = true,
  sidebarContent,
  topbarContent,
  mainContent,
  agentSize = 240
}) {
  useEffect(() => {
    return () => {
      if (typeof window !== 'undefined' && window.parent && window.parent !== window) {
        try {
          window.parent.postMessage({ type: 'child-ready' }, '*')
        } catch (e) {
        }
      }
    }
  }, [])
 
  const defaultTopbar = (
    <>
      <Skeleton width="32px" height="32px" borderRadius="8px" />
      <Skeleton width="120px" height="24px" />
      <div style={{ flex: 1 }} />
      <Skeleton width="32px" height="32px" circle />
    </>
  )

  const defaultSidebar = (
    <>
      <Skeleton width="80%" height="24px" />
      <Skeleton width="100%" height="40px" borderRadius="8px" />
      <Skeleton width="100%" height="40px" borderRadius="8px" />
      <Skeleton width="100%" height="40px" borderRadius="8px" />
    </>
  )

  const defaultMainContent = (
    <>
      <div style={{ display: 'flex', gap: '24px', marginBottom: '32px' }}>
         <Skeleton width="200px" height="32px" />
         <div style={{ flex: 1 }} />
         <Skeleton width="100px" height="32px" />
      </div>
      <Skeleton height="200px" width="100%" borderRadius="12px" style={{ marginBottom: '24px' }} />
      <Skeleton height="400px" width="100%" borderRadius="12px" />
    </>
  )

  return (
    <Container>
      {hasTopbar && (
        <TopBar>
          {topbarContent || defaultTopbar}
        </TopBar>
      )}
      
      <div style={{ flex: 1, display: 'flex' }}>
        {hasSidebar && (
          <Sidebar>
            {sidebarContent || defaultSidebar}
          </Sidebar>
        )}
        
        <ContentArea>
           {mainContent || defaultMainContent}
        </ContentArea>
      </div>
      
      <Overlay>
        <AiAgentWidget size={agentSize} thinking={true} animationMode="rotating" />
      </Overlay>
    </Container>
  )
}
